/*============================================================
   REDUX DEPENDENCIES
============================================================*/
import { createSlice } from "@reduxjs/toolkit";

//CREATING A DATA SLICE
const applicationSlice = createSlice({
  //REFERENCE NAME OF THIS DATA SLICE
  name: "app",

  initialState: {
    applicantCount: "",
    currApplicant: "first",
  },

  reducers: {
    updateApplication: (state, action) => {
      const actionType = action.payload.type;
      const payload = action.payload.payload;

      switch (actionType) {
        case "UPDATE_APP_COUNT":
          state.applicantCount = payload;
          break;

        case "UPDATE_CURR_APPLICANT":
          state.currApplicant = payload;
          break;

        default:
          break;
      }
    },
  },
});

//Action creators are generated for each case reducer function
//This declares action that can be acted on this slice of data
export const { updateApplication } = applicationSlice.actions;

export default applicationSlice.reducer;
